import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Input, Table, Switch, Space, Tag, notification, DatePicker, Tabs, Select } from 'antd';
import { DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { CaretRightOutlined, CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import moment, { normalizeUnits } from 'moment';
import LayoutDetail from '../../Layout'
import { connect } from 'react-redux'
import { useLocation } from "react-router-dom";
import LoadingIndicator from "../../../partials/LoadingIndicator";
import EvHeader from '../../../partials/EvHeader';
import Highlighter from 'react-highlight-words';

const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;





const msgTabJaAberta = () => {
    notification['error']({
        message: 'Tab já está aberta',
        description:
            'Essa nova aba ta tentando criar já existe',
    });
};

const Nfs = ({ notas, isLoading, tabsFiliais, asyncListarDOCS, notasFiltradas, setIsLoading, LimparTabs, LimparNotas, asyncAtulizaTodasTabs, asyncAdicionarFiliais, asyncListarNFEs, asyncListarNotasFiltradas, }) => {

    const [enableSelectFiliais, setDisaleSelecFiliais] = useState(true);
    const [dataInicio, setDataInicio] = useState(moment(Date.now() - 1).subtract(1, 'd').format('YYYY-MM-DD'));
    const [dataFim, setDataFim] = useState(moment(Date.now()).format('YYYY-MM-DD'));
    const [filiais, setFilial] = useState([])
    const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY'];

    const [searchedColumn, setSearchedColumn] = useState('');
    const [searchText, setSearchText] = useState('');
    const location = useLocation();
    const [tipoDocumento, setTipoDocumento] = useState('NF');
    const [documentosSelecionados, SetdocumentosSelecionados] = useState([])


    function gerarId() {
        return '_' + Math.random().toString(36).substr(2, 9);
    };
    useEffect(async () => {
        await setIsLoading(true);
        console.log(':::: 01 - BUSCANDO NOVAS NOTAS... ::::')
        if (tipoDocumento === 'NF') {

            console.log(':::: 01.1.1 - BUSCANDO NOTAS NF... ::::')
            await asyncListarNFEs({dataInicio:dataInicio, dataFim:dataFim});
        } else {
            console.log(':::: 01.1.2 - BUSCANDO MOVIMENTACOES... ::::');
            await asyncListarDOCS({ dataMovimento: dataInicio });
        }
        console.log(':::: 01.1 - NOVOS DADOS DE NOTAS... ::::')
        await setIsLoading(false);
    }, [dataFim]);
    useEffect(async () => {
        await setIsLoading(true);
        console.log(':::: 01 - BUSCANDO NOVAS NOTAS... ::::')
        if (tipoDocumento === 'NF') {

            console.log(':::: 01.1.1 - BUSCANDO NOTAS NF... ::::')
            await asyncListarNFEs({dataInicio:dataInicio, dataFim:dataFim});
        } else {
            console.log(':::: 01.1.2 - BUSCANDO MOVIMENTACOES... ::::');
            await asyncListarDOCS({ dataMovimento: dataInicio });
        }
        console.log(':::: 01.1 - NOVOS DADOS DE NOTAS... ::::')
        await setIsLoading(false);
    }, [dataInicio]);

    useEffect(async () => {
        if (notas != undefined) {
            if (notas.length > 0) {
                console.log(':::: 03 - ADICIONADO TAB... ::::');
                await SetdocumentosSelecionados(notas);
                console.log(':::: 03 - TAB ADICIONADO! ::::');
                setDisaleSelecFiliais(false);
            }
        }
    }, [notas])

    async function alterarDataNotasInicial(date, dateString) {
        setDataInicio(date.format('YYYY-MM-DD'));
    }
    async function alterarDataNotasFinal(date, dateString) {
        setDataFim(date.format('YYYY-MM-DD'));
    }

    // async function filter(arr, e) {
    //     const cupom = parseInt(e.target.value);
    //     return (await Promise.all(arr.filter(nota => Number.isInteger(cupom) == false ? nota.cliente.includes(e.target.value.toUpperCase()) : nota.numeroCupomSat === cupom)))
    // }

  
      async function addFilial(filial) {      
        setFilial(filiais => [...filiais, filial]);
     }
     async function removerFilial(filial) {      
        setFilial(filiais.filter(item => item !== filial));
     }



    useEffect(async () => {
        setIsLoading(true);
       console.log('FILIAIS AGORA é', filiais)
       notasFiltradas = [];
       if(filiais.length > 0) {
       await Promise.all(
            notas.map(item => {
                filiais.map(filial => {
                        if(item.filial === filial) {
                            notasFiltradas.push(item)
                        }
                })
            })       
        )} else {
            console.log('Recuperando todas as notas', notas);
            await asyncListarNFEs({dataInicio:dataInicio, dataFim:dataFim});
        }
       SetdocumentosSelecionados(notasFiltradas);
       setIsLoading(false);

    }, [filiais])

    useEffect(async () => {
        console.log(':::: TIPO DE DOCUMENTO ::::', tipoDocumento)
        await LimparTabs();
        await LimparNotas();
        if (tipoDocumento === 'NF') {
            console.log(':::: 01.1.2 - BUSCANDO NOTAS NFE QUANDO MUDAR TIPO DOCUMENTO... ::::');
            await asyncListarNFEs({dataInicio:dataInicio, dataFim:dataFim});
        } else {
            console.log(':::: 01.1.2 - BUSCANDO MOVIMENTACOES QUANDO MUDAR TIPO DOCUMENTO.... ::::');
            await asyncListarDOCS({ dataMovimento: dataInicio });
        }
        setIsLoading(false);
    }, [tipoDocumento]);

    function alteraTipoDocumento(checked) {
        setIsLoading(true)
        if (checked === true) {
            setTipoDocumento('NF');
        } else {
            setTipoDocumento('DOC');
        }
    }

    // async function montarTab(filial, resultadoBusca = false, textoBusca = '', notasFiltradasResultado = notasFiltradas) {
    //     await setIsLoading(true);
    //     var tabFilial = <></>;
    //     console.log('[:::: BEM VINDO AO PROCESSO DE MONTAGEM DE ABAS ::::]');

    //     if (resultadoBusca === true) {
    //         console.log('[:::: ENTROU NO MODO BUSCA ::::]')
    //         tabFilial = <TabPane tab={'Resultado - ' + textoBusca} key={gerarId()}>{addTabNotasPorFiltro(notasFiltradasResultado)} </TabPane>
    //         await asyncAdicionarFiliais(tabFilial);
    //         await setIsLoading(false)
    //         return;
    //     } else {
    //         console.log('[:::: ENTROU NO MODO FILIAL ::::]')
    //         if (filial === undefined) {
    //             return <TabPane tab='Nenhuma filial selecionada'></TabPane>
    //         }
    //         if (tipoDocumento === 'NF') {
    //             tabFilial = <TabPane tab={filial + ' - ' + moment(selectedDate).format('DD/MM/YYYY')} key={gerarId()}>{await addTabNotas(filial)} </TabPane>
    //             asyncAdicionarFiliais(tabFilial)
    //         } else {
    //             tabFilial = <TabPane tab={filial + ' - ' + moment(selectedDate).format('DD/MM/YYYY')} key={gerarId()}>{await addTabMovimentos(filial)} </TabPane>
    //             asyncAdicionarFiliais(tabFilial)
    //         }

    //         await setIsLoading(false)
    //     }
    // }

 
    const filtrarColuna = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    autoFocus
                    placeholder={`Buscar`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => buscarTextoGrid(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => buscarTextoGrid(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
              </Button>
                    <Button onClick={() => resetarBusca(clearFilters)} size="small" style={{ width: 90 }}>
                        Limpar
              </Button>
                   
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {

        },
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                    text
                ),
    });

    const buscarTextoGrid = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const resetarBusca = clearFilters => {
        clearFilters();
        setSearchText('');
        setSearchedColumn('');
    };

    const columns = [
        {
            dataIndex: 'sucesso',
            width: 5,
            title: 'Status',
            width: 5,
            render: text =>
                text === true ?
                    (
                        <CheckCircleOutlined style={{ color: 'green' }} />
                    ) : (
                        text === false ? (
                            <CloseCircleOutlined style={{ color: 'red' }} />
                        ) : null
                    )
        },
        {
            title: 'Cliente',
            dataIndex: 'cliente',
            width: 250,
            ...filtrarColuna('cliente'),
        },
        {
            title: 'Cupom',
            dataIndex: 'numeroCupomSat',
            width: 150,
            ...filtrarColuna('numeroCupomSat'),
        },
        {
            title: 'Data Operação:',
            dataIndex: 'dataOperacao',
            width: 150,
            render: text => <p>{moment(text).format('DD/MM/YYYY')}</p>,
            ...filtrarColuna('dataOperacao'),

        },
        {
            title: 'Filial',
            dataIndex: 'filial',
            width: 150,
            ...filtrarColuna('filial'),

        },
        {
            title: 'Nota',
            dataIndex: 'numeroNota',
            width: 150,
            ...filtrarColuna('numeroNota'),

        },
        {
            title: 'XML',
            dataIndex: 'urlXmlNota',
            width: 150,
            render: text =>
                <Button type="primary" href={text}
                    shape="round" icon={<DownloadOutlined />}>
                    Download
          </Button>
        },
        {
            title: 'PDF',
            dataIndex: 'urlPdfNota',
            width: 150,
            render: text =>
                <Button type="primary" href={text}
                    shape="round" icon={<DownloadOutlined />} >
                    Download
          </Button>

        },
    ];
    const columnsDocs = [
        {
            fixed: 'left',
            title: 'Cliente',
            dataIndex: 'cliente',
            key: 'cliente',
            ...filtrarColuna('cliente'),
        },
        {
            title: 'Cupom',
            dataIndex: 'numeroCupomSat',
            key: 'numeroCupomSat',
            width: 70,
            ...filtrarColuna('numeroCupomSat'),
        },
        {
            title: 'CPF',
            dataIndex: 'cpfCliente',
            key: 'cpfCliente',
            ...filtrarColuna('cpfCliente'),

        },
        {
            title: 'Filial',
            dataIndex: 'filial',
            key: 'filial',
            ...filtrarColuna('filial'),

        },
        {
            title: 'Endereço',
            dataIndex: 'enderecoCliente',
            key: 'enderecoCliente',
        },
        {
            title: 'UF',
            dataIndex: 'estadoCliente',
            key: 'estadoCliente',
            width: 50,
        },
       
        {
            title: 'Complemento',
            dataIndex: 'complementoLogradouroCliente',
        },
        {
    
            width: 100,
            key: 'valorTotal',
            title: 'Valor Total',
            dataIndex: 'valorTotal',
            render: text => <Tag color="#87d068">{text.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Tag>,
        },
        {
            width: 100,
    
            title: 'Valor Formula',
            dataIndex: 'valorFormula',
            render: text => <Tag color="#87d068">{text.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Tag>,
        },
        {
            width: 100,
    
            title: 'Valor Revenda',
            dataIndex: 'valorRevenda',
            render: text => <Tag color="#87d068">{text.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Tag>,
        },
    ];
    return (
        <LayoutDetail breadCrumbs={['Setor Fiscal', 'NFE-s/Movimento']}>
            
         
            <Row style={{ padding: 10 }}>
                <Col style={{padding:10, marginRight:5}} xs={24} sm={24} md={2} lg={2} xl={2}>
                    <Switch
                        checkedChildren={'NFE-s'}
                        unCheckedChildren={'Movimentos'}
                        onChange={alteraTipoDocumento}
                        defaultChecked
                    />
                </Col>
                <Col xs={24} sm={24} md={3} lg={3} xl={3} style={{ paddingTop: 5 }}>
                    <DatePicker onChange={(date, dateString) => alterarDataNotasInicial(date, dateString)} style={{ width: '100%' }} defaultValue={moment(Date.now() - 1).subtract(1, 'd')} format={dateFormatList} />
                </Col>
                <Col xs={24} sm={24} md={3} lg={3} xl={3} style={{ paddingTop: 5 }}>
                    <DatePicker   disabled={ tipoDocumento === 'NF' ? false : true } onChange={(date, dateString) => alterarDataNotasFinal(date, dateString)} style={{ width: '100%' }} defaultValue={moment()} format={dateFormatList} />
                </Col>
                {/* <Col xs={24} sm={24} md={21} lg={18} xl={18}>
                    <Select
                        showSearch
                        disabled={ tipoDocumento === 'NF' ? enableSelectFiliais : true }
                        mode="multiple"
                        
                        style={{ width: '95%', margin: 5 }}
                        placeholder="Filial"
                        optionFilterProp="children"
                        onSelect={addFilial}
                        onDeselect={removerFilial}
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }>
                        <Option d value="001 - MATRIZ"> 01 - MATRIZ</Option>
                        <Option value="004 - LOJA HARMONY"> 04 - HARMONY</Option>
                        <Option value="030 - CENTRAL ATENDIMENTO">30 - CENTRAL</Option>
                        <Option value="033 - FILIAL RIOMAR FORTAL">33 - RIO MAR</Option>
                    </Select>
                </Col> */}
            </Row>
            {
                isLoading === false ? (

                    notas.length != undefined && notas.length > 0 ? (
                        <>
                            <Row style={{ backgroundColor: '#eee', padding: 10 }}>
                                <Col span={24}>
                                    <Table columns={tipoDocumento === 'NF' ? columns : columnsDocs} dataSource={documentosSelecionados} scroll={{ x: 1100 }} pagination={{ pageSize: 10 }} />
                                </Col>
                            </Row>
                        </>
                    ) : (
                            <center>
                                <h2 style={{ color: '#555', marginTop: 50 }}>Não foi possível localizar notas para a data selecionada.</h2>
                            </center>
                        )

                ) : (<LoadingIndicator menssagem='Carregando informacoes de notas' />)
            }



        </LayoutDetail>

    );
}

const mapState = (state) => ({
    notas: state.nf.notas,
    isLoading: state.nf.isLoading,
    tabsFiliais: state.nf.tabsFiliais,
    notasFiltradas: state.nf.notasFiltradas
})
const mapDispatch = (dispatch) => ({
    LimparNotas: dispatch.nf.LimparNotas,
    LimparTabs: dispatch.nf.LimparTabs,
    setIsLoading: payload => dispatch.nf.setIsLoading(payload),
    asyncListarNFEs: payload => dispatch.nf.asyncListarNFEs(payload),
    asyncListarNotasFiltradas: payload => dispatch.nf.asyncListarNotasFiltradas(payload),
    asyncAdicionarFiliais: payload => dispatch.nf.asyncAdicionarFiliais(payload),
    asyncAtulizaTodasTabs: payload => dispatch.nf.asyncAtulizaTodasTabs(payload),
    asyncListarDOCS: payload => dispatch.nf.asyncListarDOCS(payload)
})

export default connect(mapState, mapDispatch)(Nfs)
